import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import MembreService from '../../services/MembreService';

const initialState = {
  Membres: [],
  MembreId: {},
  pageSize: 20,
  currentPage: 1,
  totalElements: 0,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: '',
};

export const createMembre = createAsyncThunk(
  'Membre/create',
  async (data, thunkAPI) => {
    try {
      return await MembreService.createMembre(data);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllMembre = createAsyncThunk(
  'Membre/getAll',
  async (_, thunkAPI) => {
    try {
      return await MembreService.getAll();
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateMembre = createAsyncThunk(
  'Membre/update',
  async (data, thunkAPI) => {
    try {
      return await MembreService.updateMembre(data);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getMembreById = createAsyncThunk(
  'Membre/id',
  async (id, thunkAPI) => {
    try {
      return await MembreService.getById(id);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteMembre = createAsyncThunk(
  'Membre/delete',
  async (id, thunkAPI) => {
    try {
      return await MembreService.deleteMembre(id);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const MembreSlice = createSlice({
  name: 'membres',
  initialState,
  reducers: {
    clearMembre: state => initialState,
  },
  extraReducers: builder => {
    builder
      .addCase(createMembre.pending, state => {
        state.isLoading = true;
      })
      .addCase(createMembre.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const created = action.payload?.result || action.payload?.data || action.payload;
        if (created) {
          state.Membres.unshift(created);
        }
      })
      .addCase(createMembre.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getAllMembre.pending, state => {
        state.isLoading = true;
      })
      .addCase(getAllMembre.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const payload = action.payload?.result || action.payload?.data || action.payload;
        const items = Array.isArray(payload) ? payload : payload?.items || payload?.data || [];
        state.Membres = items;
        const pagination = action.payload?.pagination || {};
        state.currentPage = pagination.current_page || 1;
        state.pageSize = pagination.limit || items.length || 20;
        state.totalElements = pagination.total_items || items.length || 0;
      })
      .addCase(getAllMembre.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(updateMembre.pending, state => {
        state.isLoading = true;
      })
      .addCase(updateMembre.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
      })
      .addCase(updateMembre.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getMembreById.pending, state => {
        state.isLoading = true;
      })
      .addCase(getMembreById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.MembreId = action.payload?.result || action.payload?.data || action.payload;
      })
      .addCase(getMembreById.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(deleteMembre.pending, state => {
        state.isLoading = true;
      })
      .addCase(deleteMembre.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const deletedId = action.payload?.data || action.payload?.id;
        state.Membres = state.Membres.filter(item => item.id !== deletedId);
      })
      .addCase(deleteMembre.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { clearMembre } = MembreSlice.actions;
export default MembreSlice.reducer;
